// Odhad barvy nitě podle názvu — Databáze nití barvu nemá, jen český název.
// Nejdřív přesné názvy, které v databázi jsou; nový název se odhadne podle
// základní barvy a slov „světle"/„tmavě".

const PRESNE: Record<string, string> = {
  broskvová: '#f9b38a',
  béžová: '#d8c3a0',
  bílá: '#ffffff',
  fialová: '#8e44ad',
  fuchsiová: '#d6157f',
  hořčicová: '#d4a017',
  khaki: '#8a8a5c',
  'koňaková - hnědá': '#8b4a1f',
  'královsky modrá': '#2445b5',
  modrošedá: '#6b7f99',
  petrolejová: '#1f6b73',
  starorůžová: '#c98b94',
  'starorůžová - světlá': '#e3b8bd',
  'středně šedá': '#8c8c8c',
  'sv. šedá': '#c4c4c4',
  'svítivě růžová': '#ff3fa4',
  'svítivě zelená': '#4cff3a',
  'světle fialová': '#c7a3e0',
  'světle modrá': '#8fc4ef',
  'světle růžová': '#f7c1d4',
  'světle zelená': '#9fdc8a',
  'tm. modrá': '#1b2a5c',
  'tm. šedá': '#4a4a4a',
  'tmavě fialová': '#4b2366',
  'tmavě hnědá': '#4a2c1a',
  'tmavě růžová': '#d1477a',
  vanilka: '#f3e5ab',
  vínová: '#7b1e3a',
  černá: '#1a1a1a',
  červená: '#d32f2f',
};

const ZAKLAD: [RegExp, string][] = [
  [/růžov/, '#ec8fb3'],
  [/fialov/, '#8e44ad'],
  [/modr/, '#2f6fd1'],
  [/zelen/, '#3a9a4a'],
  [/žlut/, '#f2d024'],
  [/oranž/, '#f28c28'],
  [/červen/, '#d32f2f'],
  [/hněd/, '#7a4a26'],
  [/šed/, '#8c8c8c'],
  [/čern/, '#1a1a1a'],
  [/bíl/, '#ffffff'],
  [/béž|krém|vanil/, '#e8d9b5'],
];

/** Posune hex barvu k bílé (k > 0) nebo k černé (k < 0). */
function posun(hex: string, k: number): string {
  const n = Number.parseInt(hex.slice(1), 16);
  const kanal = (c: number) => Math.round(k > 0 ? c + (255 - c) * k : c * (1 + k));
  const r = kanal((n >> 16) & 255);
  const g = kanal((n >> 8) & 255);
  const b = kanal(n & 255);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

/** Odhadnutá barva nitě jako hex, nebo null (neznámý název). */
export function barvaNiti(nazev: string): string | null {
  const n = nazev.trim().toLowerCase();
  if (!n) return null;
  const presna = PRESNE[n];
  if (presna) return presna;
  const zaklad = ZAKLAD.find(([re]) => re.test(n))?.[1];
  if (!zaklad) return null;
  if (/světl|sv\./.test(n)) return posun(zaklad, 0.45);
  if (/tmav|tm\./.test(n)) return posun(zaklad, -0.45);
  return zaklad;
}
